import { ref } from 'vue';

export default function useEventBus() {
  const listeneres = ref({});

  const addEventListener = (eventName, callback) => {
    listeneres.value[eventName] = callback;
  };

  const emit = (key, payload) => {
    if (typeof listeneres.value[key] !== 'function') {
      return;
    }
    listeneres.value[key](payload);
  };

  const removeEventListener = (eventName) => {
    delete listeneres.value[eventName];
  };

  return {
    emit,
    addEventListener,
    removeEventListener,
  };
}
